export default __webpack_public_path__ + "static/media/icon-alert-coins.1f163212.png";